(function () {
  'use strict';

  angular.module('app').component('packagesPage', packageListCtrl());

  function packageListCtrl() {
    return {
      bindings: {},
      controller: PackageListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/packages/packages-page.component.html',
    };
  }

  PackageListCtrl.$inject = [
    '$location',
    'AbilityService',
    'SessionService',
    'PackageService',
    'LanguageService',
  ];

  function PackageListCtrl(
    $location,
    AbilityService,
    SessionService,
    PackageService,
    LanguageService
  ) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_package_accountadmin'),
    };

    vm.userLanguageCode = SessionService.getUserLanguage().code;

    // Methods
    vm.createItem = createItem;
    vm.onShowItem = onShowItem;

    // Initializers
    getDefaultLanguage();

    function getDefaultLanguage() {
      LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function (
        data
      ) {
        vm.defaultLanguage = data.items.lang;

        getPackages();
      });
    }

    function getPackages() {
      let filterCriteria = PackageService.getFilterCriteria();
      // filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      PackageService.getPackages(filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function createItem() {
      $location.path('/packages/new');
    }

    function onShowItem(item, mode) {
      $location.path(`/packages/${item.id}`).search({ mode: mode });
    }
  }
})();
